<template>
  <div class="qunti-huaxiang-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle">
      <div class="single-line jingquziyuanjibiejiegou">
        <div class="chart-title">景区资源级别结构</div>
        <div class="chart-content">
          <SingleBar
            :chartData="JingquZiyuanJibieJiegouData"
            xy="y"
            :barWidth="20"
            id="jingquziyuanjibiejiegou"
          />
        </div>
      </div>
      <div class="single-line jingqumenpiaojiagejiegou">
        <div class="chart-title">景区门票价格结构（平日价格）</div>
        <div class="chart-content">
          <RoseCircle
            :chartData="JingquMenpiaoJiageJiegouFenxiData"
            id="jingqumenpiaojiagejiegou"
            v-if="JingquMenpiaoJiageJiegouFenxiData.length"
          />
        </div>
      </div>
      <div class="single-line gediqujingquziyuanduibi">
        <div class="chart-title">各地区景区资源对比</div>
        <div class="chart-content">
          <StackBar2
            :barWidth="28"
            :chartData="GediquJingquZiyuanDuibiData"
            id="gediqujingquziyuanduibi"
            xy="y"
          />
        </div>
      </div>
      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";
import RoseCircle from "@/components/Echarts/RoseCircle.vue";
import StackBar2 from "@/components/Echarts/StackBar2.vue";
import SingleBar from "@/components/Echarts/SingleBar.vue";

export default {
  name: "JiudianZiyuanFenxiDetail",
  components: {
    ChildModal,
    RoseCircle,
    StackBar2,
    SingleBar
  },
  props: {},
  data() {
    return {
      JingquZiyuanJibieJiegouData: null,
      JingquMenpiaoJiageJiegouFenxiData: [],
      GediquJingquZiyuanDuibiData: null
    };
  },
  mounted() {
    // 请求景区资源级别结构
    fetch(
      "/data/ZiyuanPinggu/JingquZiyuanFenxiDetail/JingquZiyuanJibieJiegou.json"
    )
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.JingquZiyuanJibieJiegouData = json.data;
      });
    // 请求景区门票价格结构分析
    fetch(
      "/data/ZiyuanPinggu/JingquZiyuanFenxiDetail/JingquMenpiaoJiageJiegouFenxi.json"
    )
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.JingquMenpiaoJiageJiegouFenxiData = json.data;
      });

    // 请求各地区景区资源对比
    fetch(
      "/data/ZiyuanPinggu/JingquZiyuanFenxiDetail/GediquJingquZiyuanDuibi.json"
    )
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.GediquJingquZiyuanDuibiData = json.data;
      });
  },
  methods: {}
};
</script>

<style scoped lang="less">
.jingqumenpiaojiagejiegou .chart-content {
  width: 80%;
  height: 210px;
  transform: translateX(-0.7rem);
}
.gediqujingquziyuanduibi .chart-content {
  height: 240px;
  transform: translateX(0.2rem);
}
.jingquziyuanjibiejiegou .chart-content {
  width: 95%;
  height: 230px;
}
</style>
